import React, { useState, useEffect } from "react";
import { Typography, Grid, Card, CardContent } from "@mui/material";
import Zoom from "@mui/material/Zoom";
import { MonetizationOn, CameraAlt, AttachMoney, Build, Home, Campaign } from "@mui/icons-material"; // Import Icons
import Box from "@mui/material/Box"; // Used to align icon and text

const cards = [
  { id: 1, title: "Nontraditional Financing", content: "At RocketOffer.com, we combine traditional financing with non-traditional options to identify the best solutions for your investment opportunities. By blending these approaches, we can offer flexible, tailored financing that ensures a quick and efficient closing process. Our goal is to provide you with the most effective financing strategy to meet your needs and close swiftly.", icon: <MonetizationOn sx={{ color: "primary.main", fontSize: 30 }}/> },
  { id: 2, title: "Professional Photos & Video", content: "Showcasing properties effectively is key to standing out in a competitive market. We work directly with top industry experts to ensure the highest quality photos and videos available. This strategic presentation helps highlight your property's unique features and attract the right buyers.", icon: <CameraAlt sx={{ color: "primary.main", fontSize: 30 }}/> },
  { id: 3, title: "Cash Offer", content: "At RocketOffer.com, we strive to stand out from traditional cash offer companies in the industry. By fine-tuning our approach, we tailor our services to meet the unique needs of each client. This enables us to help our clients close more deals with greater ease and success.", icon: <AttachMoney sx={{ color: "primary.main", fontSize: 30 }}/> },
  { id: 4, title: "Renovations", content: "RocketOffer.com has partnered with top industry veterans to provide the smoothest transition process for flipping houses quickly and affordably. Our expert team ensures a streamlined experience, helping you navigate every step with ease. Learn more about becoming a RocketOffer Pro and unlock the potential to accelerate your success in the real estate market.", icon: <Build sx={{ color: "primary.main", fontSize: 30 }}/> },
  { id: 5, title: "Home Staging", content: "At RocketOffer.com, we focus on every aspect of the business, from design and furnishing to home staging, to help you sell your properties faster and more efficiently. Our expert staging crews create a vision that allows potential buyers to envision how they could make the space their own. By showcasing your property as a true 'home,' we help buyers connect emotionally and make quicker decisions.", icon: <Home sx={{ color: "primary.main", fontSize: 30 }}/> },
  { id: 6, title: "Premium Marketing", content: "RocketOffer.com provides a flexible marketing strategy with a variety of packages designed to suit your unique needs and budget. We offer tailored solutions that ensure your property gets the attention it deserves. Whether you're working with a tight budget or seeking premium exposure, we have the right package for you.", icon: <Campaign sx={{ color: "primary.main", fontSize: 30 }}/> },
];

const StaggeredCards = () => {
  const [checked, setChecked] = useState(cards.map(() => false));

  useEffect(() => {
    cards.forEach((_, index) => {
      setTimeout(() => {
        setChecked((prev) => {
          const newChecked = [...prev];
          newChecked[index] = true;
          return newChecked;
        });
      }, index * 500);
    });
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: '#181818',
        color: 'white',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        borderRadius: 4,
        px: { xs: 3, sm: 6 },
        py: { xs: 4, sm: 6 },
        mx: 'auto',
        maxWidth: '1800px',
        mb: 6,
        boxShadow: 'inset 0 0 20px rgba(255, 255, 255, 0.1)',
      }}
    >
      <Typography variant="h4" gutterBottom align="center" sx={{ fontWeight: 'bold' }}>
        Rocket Offer Services
      </Typography>

      <Grid container spacing={3} justifyContent="center" sx={{ pt: 2 }}>
        {cards.map((card, index) => (
          <Grid item key={card.id}>
            <Zoom in={checked[index]} timeout={500}>
              <Card sx={{ maxWidth: 500, p: 2 }}>
                <CardContent>
                  <Box display="flex" alignItems="center" gap={1}>
                    {card.icon}
                    <Typography variant="h5">{card.title}</Typography>
                  </Box>
                  <Typography variant="body2">{card.content}</Typography>
                </CardContent>
              </Card>
            </Zoom>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default StaggeredCards;
